var _style, _circle, _circle2, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDifferenceImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:none;stroke:#231f20;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("path", {
    d: "M115 100c0-25.91 14.08-48.51 35-60.61A69.667 69.667 0 0 0 115 30c-38.66 0-70 31.34-70 70s31.34 70 70 70c12.75 0 24.7-3.43 35-9.39-20.92-12.1-35-34.7-35-60.61z",
    style: {
      fill: "#39cac4"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 115,
    cy: 100,
    r: 70
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 185,
    cy: 100,
    r: 70
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1, 0, 0, 1, 74.908731, 52.387158)",
    style: {
      fontFamily: "&quot",
      fontSize: 11,
      textTransform: "uppercase",
      whiteSpace: "pre"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", null, "preview")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    dy: "1em"
  }, "\u200B")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", null, "pool"))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1, 0, 0, 1, 227.189243, 52.356587)",
    style: {
      fontFamily: "&quot",
      fontSize: 11,
      textAnchor: "end",
      textTransform: "uppercase",
      whiteSpace: "pre"
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", null, "selected")), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    dy: "1em"
  }, "\u200B")), _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", null, "pools"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifferenceImg);
export default __webpack_public_path__ + "static/media/differenceImg.a805d663606c8acd06e851126e8796a9.svg";
export { ForwardRef as ReactComponent };